import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-tcp-black py-8 border-t border-white/10 text-center px-4" data-id="element-27">
      <div className="max-w-7xl mx-auto flex flex-col items-center" data-id="element-28">
        <h2 className="font-serif text-xl font-semibold text-white mb-2" data-id="element-29">
          The Christmas Palace
        </h2>
        <p className="text-tcp-red text-sm font-medium tracking-widest uppercase mb-6" data-id="element-30">
          Commercial Division
        </p>

        <div className="text-tcp-gray text-sm flex flex-col md:flex-row items-center gap-2 md:gap-6" data-id="element-31">
          <span data-id="element-32">
            &copy; {currentYear} The Christmas Palace. All rights reserved.
          </span>
          <span className="hidden md:inline text-white/20" data-id="element-33">|</span>
          <span data-id="element-34">Since 1992</span>
        </div>
      </div>
    </footer>;
}